module.exports = __webpack_public_path__ + "media/images/partner/pic_3-9e49b385a42b59bee33eb70d668ba5db.png";